import React from "react";

/**
 * SelfHealBadge Component
 * 
 * Displays the healing status of a test case with appropriate icon and styling.
 * 
 * Props:
 * - isHealed: null | true | false
 *   - null: Script created but never executed (Not Run)
 *   - true: Healing is pending, requires action (Healing Pending)
 *   - false: Script has been healed (Healed)
 * - onClick: Callback function triggered when clicking the badge (only for is_healed === true)
 * - testCaseId: ID of the test case (for accessibility)
 */
const SelfHealBadge = ({ isHealed, onClick, testCaseId }) => {
  if (isHealed === null) {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-100 text-gray-700 text-sm font-medium"
        title="Script created, never executed"
      >
        <span className="text-lg">⏸️</span>
        {/* <span>Not Run</span> */}
      </div>
    );
  }

  if (isHealed === true) {
    return (
      <button
        onClick={onClick}
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-100 text-amber-800 text-sm font-medium hover:bg-amber-200 transition-colors cursor-pointer"
        title="Click to view and approve healing proposals"
        aria-label={`Healing pending for test case ${testCaseId}`}
      >
        <span className="text-lg animate-pulse">⚠️</span>
        {/* <span>Healing Pending</span> */}
      </button>
    );
  }

  if (isHealed === false) {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100 text-green-700 text-sm font-medium"
        title="Script has been successfully healed"
      >
        <span className="text-lg">✅</span>
        {/* <span>Healed</span> */}
      </div>
    );
  }

  return null;
};

export default SelfHealBadge;
